import React, { useState, useEffect, useCallback } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { isLogin, setAuthToken } from '../../utils';
import HttpService from '../../services/httpService';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { useSelector, connect } from "react-redux";
import { setUserDetails } from '../../redux/actions/userAction';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import decorpotLogo from '../../assets/img/org/deco_white_logo.png';
import { ROLENAME } from '../../utils';
import { getSourceOfLeadData } from '../../redux/actions/leadSourceActions';
import { useDispatch } from 'react-redux';
import "../../App.css"
// Responsive styles with media queries
const useStyles = makeStyles(theme => ({
  loginButton: {
    backgroundColor: 'white',
    marginTop: '10%',
    color: '#2c2e3e',
    padding: '8px 16px',
    borderRadius: '50px',
    width: '100px',
    fontWeight: 500,
    transition: 'all 0.3s ease',
    "&:hover": {
      backgroundColor: "#F47E46",
      color: '#FFF2EB'
    }
  },
  forgotPassword: {
    fontSize: '12px',
    fontWeight: 200,
    color: 'white',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    "&:hover": {
      color: '#F47E46'
    }
  },
  input: {
    width: '100%',
    maxWidth: '350px',
    borderRadius: '50px',
    height: '40px',
    padding: '0 20px',
    marginBottom: '20px',
    border: 'none',
    fontSize: '14px',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'box-shadow 0.3s ease',
    "&:focus": {
      boxShadow: '0 0 3px 2px rgba(244, 126, 70, 0.5)'
    }
  }
}));

const Index = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state.user);
  const [expcenters, setExpcenters] = useState([]);
  const [locations, setLocations] = useState([]);
  const [defaultExpCenter, setDefaultExpCenter] = useState('');
  const [defaultLocation, setDefaultLocation] = useState('');

  const [formValue, setFormValue] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formValue;
  
  const onSubmit = useCallback(async () => {
    props.setLoading(true);
    try {
      let isEmailValid = email.match(
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
      );
      
      if (isEmailValid) {
        props.setLoading(false);
        localStorage.setItem('EMAIL_ID', email);
        
        if (!localStorage.getItem('TOKEN_KEY')) {
          const response = await HttpService.login(formValue);
          
          if(response.status === 202) {
            history.push('/changePassword');
            props.setSnackInfo(response.data.message, "warning");
            return;
          }
          
          let user = response.data.userDetails;
          let MyLastPasswordCreationDate = new Date(user.LastPasswordCreationDate);
          let CurrentDate = new Date();
          let timeDifference = CurrentDate.getTime() - MyLastPasswordCreationDate.getTime();
          let DaysRemainingToChangePassword = 90 - (Math.floor(timeDifference / (1000 * 60 * 60 * 24)));
          
          if(DaysRemainingToChangePassword < 1) {
            history.push('/changePassword');
            return;
          }

          await HttpService.updateUserCacheById(user._id);
          setAuthToken(response.data.token);
          localStorage.setItem('TOKEN_KEY', response.data.token);
          const userAccess = await HttpService.getUserNavDeatails(response.data.userDetails._id);
          
          if(response.data.userDetails.experienceCenterId.length !== 1) {
            props.setUserDetails({
              ...response.data.userDetails,
              selectedExpCenter: response.data.userDetails.experienceCenterId,
              selectedLocation: response.data.userDetails.locationId.map((el) => el._id),
              canAccess: userAccess.data
            });
            
            let teleCallerUser = response.data.userDetails?.roles?.find(role => (role.name === ROLENAME.TeleCallerUser));
            let teleCallerAssistantManager = response.data.userDetails?.roles?.find(role => (role.name === ROLENAME.TeleCallerAssistantManager));
            let teleCallerManager = response.data.userDetails?.roles?.find(role => (role.name === ROLENAME.TeleCallerManager));
            
            // if(teleCallerUser || teleCallerAssistantManager || teleCallerManager) {
            //   localStorage.setItem('Temp_TOKEN_KEY', localStorage.getItem('TOKEN_KEY'));
            //   props.history.push('/agentStatus');
            //   localStorage.setItem('showKnowlarityWidget', true);
            //   window.location.reload();
            // } else {
              props.history.push('/dashboard');
            // }
          } else {
            let userDetails = response.data.userDetails;
            let MyLastPasswordCreationDate = new Date(userDetails.LastPasswordCreationDate);
            let CurrentDate = new Date();
            let timeDifference = CurrentDate.getTime() - MyLastPasswordCreationDate.getTime();
            let DaysRemainingToChangePassword = 90 - (Math.floor(timeDifference / (1000 * 60 * 60 * 24)));
            
            props.setUserDetails({
              ...response.data.userDetails,
              canAccess: userAccess.data,
              selectedExpCenter: response.data.userDetails.experienceCenterId[0],
              selectedLocation: response.data.userDetails.locationId[0]._id,
              DaysRemainingToChangePassword: DaysRemainingToChangePassword
            });
            
            props.history.push('/dashboard');
          }
        } else {
          props.setUserDetails({});
          localStorage.clear();
          props.setSnackInfo('Please logout from other tabs', "error");
        }
        
        dispatch(getSourceOfLeadData());
      } else {
        props.setSnackInfo('Invalid Credentials!', "error");
      }
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error.response?.data?.failed || 'Login failed', "error");
    }
    props.setLoading(false);
  }, [formValue, email, dispatch, history, props]);

  useEffect(() => {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        onSubmit();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [formValue, onSubmit]);

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  if (isLogin()) {
    return (<Redirect to="/dashboard" />);
  }

  return (
    <div className="login-page-container">
      <div className="login-form-container">
        <div className="logo-container">
          <img src={decorpotLogo} alt="decorpot logo" className="decorpot-logo" />
        </div>
        
        <h3 className="login-title">User Account Login</h3>
        
        <div className="input-container">
          <input
            type="email"
            id="email"
            value={email}
            name="email"
            placeholder="Email ID"
            onChange={onChange}
            className={classes.input}
            autoComplete="email"
          />
          
          <input
            type="password"
            id="password"
            value={password}
            name="password"
            placeholder="Password"
            onChange={onChange}
            className={classes.input}
            autoComplete="current-password"
          />
        </div>
        
        <div className="button-container">
          <Button 
            className={classes.loginButton} 
            onClick={onSubmit} 
            variant="contained"
          >
            Sign In
          </Button>
        </div>
        
        <div className="forgot-password-container">
          <Link to="/forgotPassword" style={{ textDecoration: 'none' }}>
            <span className={classes.forgotPassword}>
              Forgot Password?
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo, setUserDetails })(Index);